import React from "react";

export default function Testimonials() {
  const testimonials = [
    {
      name: "Daniel Thompson",
      role: "Business Owner",
      text: "The Kaizen Business Solutions transformed our website and improved our online presence dramatically. Excellent communication and top-quality service!",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      name: "Sarah Williams",
      role: "Marketing Director",
      text: "Their SEO and digital marketing strategies helped us increase traffic and generate real leads. Highly recommended!",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      name: "James Carter",
      role: "IT Manager",
      text: "Reliable IT support and fast problem-solving—exactly what our company needed. A truly professional team.",
      avatar: "https://randomuser.me/api/portraits/men/68.jpg",
    },
  ];

  return (
    <section
      id="testimonials"
      className="relative py-24 bg-gray-950 text-white px-6"
    >
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-10 w-72 h-72 bg-cyan-500/20 blur-3xl"></div>
        <div className="absolute bottom-0 right-10 w-72 h-72 bg-blue-500/20 blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-5xl font-bold">
          What Our <span className="text-cyan-400">Clients Say</span>
        </h2>
        <p className="text-gray-300 text-lg mt-4 max-w-2xl mx-auto">
          We take pride in delivering high-quality technology and marketing solutions.
        </p>

        {/* Testimonials grid */}
        <div className="grid gap-10 mt-16 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className="p-8 bg-gray-900/60 border border-gray-800 rounded-2xl shadow-lg backdrop-blur-lg hover:shadow-cyan-500/20 hover:-translate-y-1 transition-all duration-300 animate-fadeIn"
            >
              <img
                src={t.avatar}
                alt={t.name}
                className="w-20 h-20 rounded-full mx-auto shadow-md border border-gray-700"
              />

              <p className="text-gray-300 mt-6 italic">"{t.text}"</p>

              <h3 className="mt-6 text-xl font-semibold text-white">{t.name}</h3>
              <span className="text-sm text-gray-400">{t.role}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
